export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGIN_DATA = 'LOGIN_DATA';
export const PROFILE_DATA = 'PROFILE_DATA';
export const COMPANY_DATA = 'COMPANY_DATA';
export const HOLIDAY_DATES = 'HOLIDAY_DATES';
export const FETCH_DailyLogs_SUCCESS = 'FETCH_DailyLogs_SUCCESS';
export const FETCH_DailyLogs_FAILURE = 'FETCH_DailyLogs_FAILURE';
export const FETCH_attendence_REQUEST = 'FETCH_attendence_REQUEST';
export const SET_EMPLOYEES_DAILY_LOGS = 'SET_EMPLOYEES_DAILY_LOGS';
export const SET_EMPLOYEES_MONTHLY_LOGS = 'SET_EMPLOYEES_MONTHLY_LOGS';
export const SET_USERNAME = 'SET_USERNAME';
export const PROJECT_NAME = 'PROJECT_NAME';
export const SET_FILTERED_BOARD_DATA = 'SET_FILTERED_BOARD_DATA';
export const SET_TASK_BOARD_DETAILS_DATA='SET_TASK_BOARD_DETAILS_DATA';
export const SET_TASK_STATUS_COUNT='SET_TASK_STATUS_COUNT;';
export const SET_TASK_STATUS_LIST='SET_TASK_STATUS_LIST';
export const SET_EPICLIST_DATA='SET_EPICLIST_DATA';
export const SET_ASSIGNEE_LIST='SET_ASSIGNEE_LIST';
export const SET_SPRINT_DATA='SET_SPRINT_DATA';
export const SET_BACKLOG_DATA='SET_BACKLOG_DATA';
export const SET_LABEL_LIST='SET_LABEL_LIST';
export const SET_TIMELINEEPIC_LIST='SET_TIMELINEEPIC_LIST';
export const SET_EPICTASK_LIST='SET_EPICTASK_LIST';
export const SET_SPRINT_LIST='SET_SPRINT_LIST';
export const SET_FILTERED_REQUEST_BODY='SET_FILTERED_REQUEST_BODY';
export const SET_STORY_POINTS='SET_STORY_POINTS';
export const SET_EPIC='SET_EPIC';
export const SET_TIMELINE_FILTERED_REQBODY='SET_TIMELINE_FILTERED_REQBODY';
export const SET_TIMELINE_FILTER='SET_TIMELINE_FILTER';
export const SET_ADMIN_BOARD_DEATILS='SET_ADMIN_BOARD_DEATILS';
export const SET_BOARD_FILTER_APPLIED='SET_BOARD_FILTER_APPLIED';
export const SET_SPACE_ASSIGNEE_LIST='SET_SPACE_ASSIGNEE_LIST';